import styled, {css} from 'styled-components'

export const StyledAvatarGroupItem = styled.div(
    ({theme: {spacing}}) => css`
        margin-right: -${spacing * 2}px;
        position: relative;

        &:last-child {
            margin-right: 0;
        }
    `
)
